const followers = [
  {
    id: 1,
    imgUrl: "/images/media5.jpg",
    altText: "Alt Text",
    title: "Thom Yorke",
    follower: "1234",
  },
  {
    id: 2,
    imgUrl: "/images/media6.jpg",
    altText: "Alt Text",
    title: "Marty Jack",
    follower: "367",
  },
  {
    id: 3,
    imgUrl: "/images/media7.jpg",
    altText: "Alt Text",
    title: "Rondon",
    follower: "56",
  },
  {
    id: 4,
    imgUrl: "/images/media8.jpg",
    altText: "Alt Text",
    title: "Anyrag Sing",
    follower: "55",
  },
  {
    id: 5,
    imgUrl: "/images/media9.jpg",
    altText: "Alt Text",
    title: "Eren Matt",
    follower: "1554",
  },
  {
    id: 6,
    imgUrl: "/images/media10.jpg",
    altText: "Alt Text",
    title: "Jesica Jones",
    follower: "557",
  },
  {
    id: 7,
    imgUrl: "/images/media11.jpg",
    altText: "Alt Text",
    title: "Job Cass",
    follower: "44",
  },
  {
    id: 8,
    imgUrl: "/images/media12.jpg",
    altText: "Alt Text",
    title: "Eric Manlo",
    follower: "57",
  },
  {
    id: 9,
    imgUrl: "/images/media13.jpg",
    altText: "Alt Text",
    title: "Anyrag Sing",
    follower: "55",
  },
  {
    id: 10,
    imgUrl: "/images/media5.jpg",
    altText: "Alt Text",
    title: "Thom Yorke",
    follower: "1234",
  },
  {
    id: 11,
    imgUrl: "/images/media6.jpg",
    altText: "Alt Text",
    title: "Marty Jack",
    follower: "367",
  },
  {
    id: 12,
    imgUrl: "/images/media7.jpg",
    altText: "Alt Text",
    title: "Rondon",
    follower: "56",
  },
  {
    id: 13,
    imgUrl: "/images/media8.png",
    altText: "Alt Text",
    title: "Anyrag Sing",
    follower: "55",
  },
  {
    id: 14,
    imgUrl: "/images/media9.png",
    altText: "Alt Text",
    title: "Eren Matt",
    follower: "1554",
  },
  {
    id: 15,
    imgUrl: "/images/media10.png",
    altText: "Alt Text",
    title: "Jesica Jones",
    follower: "557",
  },
  {
    id: 16,
    imgUrl: "/images/media11.jpg",
    altText: "Alt Text",
    title: "Job Cass",
    follower: "44",
  },
];

export function getFollowers() {
  return followers;
}
